import { ordersApi, customersApi, customersDbApi } from './api';

/**
 * How this shop's staff orders are paid for (backend lib/orderEntryMode):
 *   'shopify' — pushed to the shop's Shopify store and paid there (Twigs).
 *   'counter' — no Shopify integration: the order lives here only, is saved
 *               pay-later, and staff mark it paid when they take payment.
 *
 * Asked once per login and shared by every caller. If the question fails the
 * answer is 'shopify', which is how the form behaved before this existed.
 */
export const PAYMENT_MODES = Object.freeze({ SHOPIFY: 'shopify', COUNTER: 'counter' });

let cached = { token: undefined, promise: null };

const currentToken = () => {
  try {
    return localStorage.getItem('token');
  } catch (_) {
    return null;
  }
};

export function loadOrderEntryMode() {
  const token = currentToken();
  if (!cached.promise || cached.token !== token) {
    const promise = Promise.resolve()
      .then(() => ordersApi.getEntryConfig())
      .then(r => (r?.data?.paymentMode === PAYMENT_MODES.COUNTER ? PAYMENT_MODES.COUNTER : PAYMENT_MODES.SHOPIFY))
      .catch(() => {
        if (cached.promise === promise) cached = { token: undefined, promise: null }; // ask again next time
        return PAYMENT_MODES.SHOPIFY;
      });
    cached = { token, promise };
  }
  return cached.promise;
}

/**
 * The order form's customer lookup. Shops without Shopify search their own
 * customers; asking Shopify there only fails with "Shopify integration is not
 * configured". Both return the same result shape.
 */
export async function searchOrderCustomers(query) {
  const mode = await loadOrderEntryMode();
  return mode === PAYMENT_MODES.COUNTER ? customersDbApi.search(query) : customersApi.search(query);
}

/** Test seam. */
export function __resetOrderEntryMode() {
  cached = { token: undefined, promise: null };
}
